import React from 'react';

import { Stack, Typography } from '@mui/material';

import FullTutorialPreviewImg from '@/shared/assets/images/full-tutorial-preview.png';
import { NativeVideoPlayer } from '@/shared/ui/NativeVideoPlayer';

import { GENERATING_SUBTITLE, TUTORIAL_VIDEO_SRC } from '../../lib/constants';
import { GettingReadyBadge } from '../GettingReadyBadge';

type GeneratingCardProps = {
  title: string;
};

/** Redesigned "Generating 2.0" card: animated badge + percent-driven status title + tutorial video. */
export const GeneratingCard: React.FC<GeneratingCardProps> = ({ title }) => (
  <Stack alignItems="center" marginTop={60} paddingX={16} width="100%">
    <Stack
      sx={{
        backgroundColor: 'common.white',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 12,
      }}
      alignItems="center"
      gap={20}
      maxWidth={592}
      padding={16}
      width="100%"
    >
      <Stack alignItems="center" gap={12} width="100%">
        <GettingReadyBadge />

        <Stack alignItems="center" gap={4} width="100%">
          <Typography color="grey.900" textAlign="center" variant="title-2-md">
            {title}
          </Typography>
          <Typography color="grey.500" textAlign="center" variant="body-1">
            {GENERATING_SUBTITLE}
          </Typography>
        </Stack>
      </Stack>

      <NativeVideoPlayer
        sx={{
          aspectRatio: '16 / 9',
          borderRadius: 8,
          maxWidth: 560,
          objectFit: 'cover',
          width: '100%',
        }}
        poster={FullTutorialPreviewImg}
        src={TUTORIAL_VIDEO_SRC}
        autoPlay
        controls
        loop
      />
    </Stack>
  </Stack>
);
